import ModulesSeconde, { MIEUX_SE_CONNAITRE_ID } from 'lib/modules/seconde';
import ModulesPremiere from 'lib/modules/premiere';
import ModulesTerminale from 'lib/modules/terminale';
import { useClasse } from 'lib/hooks/queries';
import { modulePath, questionnaireStepPath } from 'lib/paths';

export const useModules = (niveau = null) => {
  const premiereSecondeModules = ModulesSeconde.concat(ModulesPremiere as any);

  // deduplicate all modules
  const allModules = Array.from(
    new Map(
      premiereSecondeModules
        .concat(ModulesTerminale as any)
        .map((item) => [item.moduleId, item])
    ).values()
  );

  let modules;

  if (!niveau) {
    modules = allModules;
  }

  if (niveau === 'premiere') {
    modules = premiereSecondeModules;
  }

  if (niveau === 'terminale') {
    modules = ModulesTerminale;
  }

  return {
    modules,
    getModuleById: (id: string) => modules?.find((m) => m.moduleId === id),
    allModules,
  };
};

export const useQuestionnairePath = () => {
  const {
    classeIsGatlRc,
    isSeconde: isClasseSeconde,
    isPremiere: isClassePremiere,
    isTerminale: isClasseTerminale,
  } = useClasse();

  return !classeIsGatlRc
    ? questionnaireStepPath(1)
    : isClasseSeconde
    ? modulePath(MIEUX_SE_CONNAITRE_ID)
    : isClassePremiere
    ? questionnaireStepPath(1)
    : isClasseTerminale
    ? questionnaireStepPath(1)
    : '';
};
